<template>
  <RevDrawer
    :name="MODAL_NAMES.BLACK_FRIDAY_SPECIAL_JP"
    :title="i18n(translations.modalTitle)"
    @close="emit('close')"
  >
    <template #body>
      <RevIllustration
        :alt="i18n(translations.modalSubTitle)"
        class="rounded-md h-auto w-full object-cover"
        :height="163"
        src="/img/product/jp/black_friday_special_modal.png"
        :width="327"
      />
      <div class="my-24 flex flex-col items-center space-y-16">
        <h2 class="heading-2 w-full text-left">
          {{ i18n(translations.modalSubTitle) }}
        </h2>
        <div>
          <p class="body-1 mb-20">
            {{ i18n(translations.modalDescription) }}
          </p>
          <p class="body-1">
            {{ i18n(translations.modalDescriptionHowToUse) }}
          </p>
        </div>
        <RevTextList variant="ordered">
          <RevTextListItem>
            <div class="text-static-default-mid">
              {{ i18n(translations.modalDescriptionHowToUseStep1) }}
            </div>
          </RevTextListItem>
          <RevTextListItem>
            <div class="text-static-default-mid">
              {{ i18n(translations.modalDescriptionHowToUseStep2) }}
            </div>
          </RevTextListItem>
        </RevTextList>
      </div>
      <ul class="text-static-default-low caption mx-20 list-disc text-justify">
        <li>{{ i18n(translations.modalDescriptionTermsOfUse1) }}</li>
        <li>{{ i18n(translations.modalDescriptionTermsOfUse2) }}</li>
        <li>{{ i18n(translations.modalDescriptionTermsOfUse3) }}</li>
        <li>{{ i18n(translations.modalDescriptionTermsOfUse4) }}</li>
        <li>{{ i18n(translations.modalDescriptionTermsOfUse5) }}</li>
      </ul>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'
import { RevTextList } from '@ds/components/TextList'
import { RevTextListItem } from '@ds/components/TextListItem'

import { MODAL_NAMES } from '~/scopes/product/pages/Product-JP/Product-JP.constants'

import translations from './BlackFridaySpecialModal.translations'

const i18n = useI18n()
const emit = defineEmits<{
  close: []
}>()
</script>

<style scoped>
ul.list-disc li::marker {
  font-size: 0.6em;
}
</style>
